module.exports = __webpack_public_path__ + "media/assets/images/logos/bulloni_digitali_favicon-40427b09ac822fa16194cacd2ebc05b6.png";